import React from "react";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { login_url } from "../globals";
import { useLogin } from "../reducers";

const LoginAgainToast = () => {
  const { t } = useTranslation();
  const { needs_login_again } = useLogin();

  if (!needs_login_again) {
    return null;
  }

  return (
    <aside
      role="alert"
      aria-live="assertive"
      className="fixed right-5 top-5 z-[1200] w-[min(460px,calc(100vw-40px))] overflow-hidden rounded-2xl border border-warning/35 bg-surface shadow-2xl shadow-warning/10"
    >
      <div className="flex gap-3 border-l-4 border-warning bg-warning/10 p-4">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-warning/20 text-warning-strong">
          <AlertTriangle className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-text">{t("authentication_required")}</p>
          <p className="mt-1 text-sm leading-5 text-text-mid">{t("login_again_message")}</p>
          <div className="mt-3">
            <button
              type="button"
              onClick={() => login_url()}
              className="inline-flex items-center rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-on-accent shadow-sm transition hover:bg-primary-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-surface"
            >
              {t("login_again")}
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default LoginAgainToast;
